<template>
  <div class="flex flex-col sm:flex-row min-w-full">
    <div v-if="reviewStore.settings.paymentOptionsImageUrl" class="w-full">
      <div class="mx-auto max-w-[450px]">
        <img
          class="mx-auto object-contain rounded-lg mt-2"
          :src="reviewStore.settings.paymentOptionsImageUrl"
          alt="Company Logo"
        />
      </div>
    </div>
    <div class="flex flex-col items-center w-full mb-4">
      <div class="my-4">
        <div class="text-xl font-bold mb-4 underline underline-offset-8">
          Invoice Total Due: {{ formatCurrency(reviewStore.invoiceAmount) }}
        </div>
        <div class="text-lg">Which payment option would you like to use?</div>
        <SquarePayment />
      </div>
      <el-button
        v-if="reviewStore.settings.acceptCardPayments"
        type="success"
        size="large"
        class="max-w-lg mx-auto"
        plain
        @click="
          navToPayment();
          toggleExpand();
        "
      >
        <Icon
          :icon="isExpanded ? 'fa-solid:chevron-up' : 'fa-solid:chevron-down'"
          class="mr-4"
        />
        Credit Card (3% transaction fee)
      </el-button>
      <div
        ref="contentRef"
        :class="{ expand: isExpanded, collapse: !isExpanded }"
        class="overflow-hidden transition-max-height duration-500 ease-in-out bg-gray-900 rounded-br-lg rounded-bl-lg w-full"
      >
        <!-- <div v-if="payWithQb"> -->
        <div>
          <div class="text-xl font-bold mt-2 underline underline-offset-4">
            {{ formatCurrency(reviewStore.invoiceCardAmount) }}
          </div>
          <div class="mt-2">(with 3% fee)</div>
        </div>
        <PayByCard />
        <!-- </div> -->
      </div>
      <PaymentOptionsWire @click="toggleExpandBankInfo" />
      <div v-if="reviewStore.settings.phoneNumber" class="mt-4">
        For questions or to pay by phone, <br />
        please call {{ reviewStore.settings.phoneNumber }}.
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from "vue";
import { useReview } from "@/stores";
import { formatCurrency } from "@/utils";
import { Icon } from "@iconify/vue";
import PayByCard from "@/components/PayByCard.vue";
import useExpandable from "@/composables/useExpandable";
import PaymentOptionsWire from "./PaymentOptionsWire.vue";
import SquarePayment from "./SquarePayment.vue";

const { isExpanded, contentRef, toggleExpand } = useExpandable();

const reviewStore = useReview();
const showBankInfo = ref(false);
const confirmMessage = ref("Click to Confirm Sent Payment");
const payWithQb = ref(false);
const payWithStripe = ref(false);

// TODO: refine once stripe is working
const navToPayment = () => {
  reviewStore.recordClick("payByCardButtonClicked");
  if (
    reviewStore.settings.qbConnected &&
    reviewStore.settings.acceptQbPayments
  ) {
    payWithQb.value = !payWithQb.value;
  } else if (
    reviewStore.settings.stripeConnected &&
    reviewStore.settings.acceptStripePayments &&
    reviewStore.stripeLink != "seven-figures or disabled"
  ) {
    reviewStore.currentComponent = "PaymentProgress";
    // setTimeout(() => {
    //   window.location.href = reviewStore.stripeLink;
    // }, 3000);
  }
};

const toggleExpandBankInfo = () => {
  // showBankInfo.value = !showBankInfo.value;
  reviewStore.recordClick("bankWireZelleButtonClicked");
};

const verifyAmount = computed(() => {
  const surcharge = 0.03;
  const totalAmountWithSurcharge = reviewStore.invoiceAmount * (1 + surcharge);
  const isAmountBelowLimit = totalAmountWithSurcharge < 100000000;
  return isAmountBelowLimit;
});
</script>
<style scoped></style>
